
export function dateTimeFormatedString(datum: any) {
    var date='';
    var time='';
    if (datum) {
        date = new Date(datum).toLocaleDateString('nl-NL',{ year: 'numeric', month: '2-digit', day: '2-digit'}).split( '/' ).reverse( ).join( '-' );
        time = new Date(datum).toLocaleTimeString('nl-NL',{ hour: '2-digit', minute: '2-digit' });
    }
    return date + ' ' + time;

}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/datetime/datetime.tsx